import CrudManager from "./CrudManager";
import { mediaUrl } from "@/lib/api";

export default function GearAdmin() {
  return (
    <CrudManager
      name="gear" title="Recommended Gear" subtitle="Affiliate product cards"
      empty={{ name: "", category: "", price_range: "", description: "", image: "", affiliate_link: "", link_label: "", youtube_video_id: "", order: 99, active: true }}
      fields={[
        { name: "name", label: "Product name" },
        { name: "category", label: "Category" },
        { name: "price_range", label: "Price range", placeholder: "£15 - £30" },
        { name: "description", label: "Simple description", type: "textarea" },
        { name: "image", label: "Image", type: "image" },
        { name: "affiliate_link", label: "Affiliate link (Amazon, TikTok, etc.)" },
        { name: "link_label", label: "Button label", placeholder: "View on Amazon", hint: "e.g. View on Amazon, View on TikTok, Shop now" },
        { name: "youtube_video_id", label: "YouTube video ID", hint: "The part after v= in the URL" },
        { name: "order", label: "Display order", type: "number" },
        { name: "active", label: "Active", type: "switch" },
      ]}
      renderSummary={(g) => (
        <>
          {g.image && <img src={mediaUrl(g.image)} alt={g.name} className="h-28 w-full object-cover rounded-lg mb-3 border border-white/10" />}
          <div className="text-[10px] uppercase tracking-widest text-[#D4AF37]">{g.category}</div>
          <h3 className="font-display text-lg">{g.name}</h3>
          <div className="text-sm text-white/50">{g.price_range} · {g.active ? "Active" : "Hidden"}</div>
        </>
      )}
    />
  );
}
